"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ScoreLayer_1 = require("./ScoreLayer");
var AudioManager_1 = require("../AudioManager");
var GameConstants_1 = require("../GameConstants");
var GameVars_1 = require("../GameVars");
var TutorialLayer_1 = require("./TutorialLayer");
var SplashState = /** @class */ (function (_super) {
    __extends(SplashState, _super);
    function SplashState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SplashState.prototype.init = function () {
        SplashState.currentInstance = this;
    };
    SplashState.prototype.create = function () {
        AudioManager_1.AudioManager.getInstance().playSound("music", 1, true);
        var background = this.add.sprite(GameConstants_1.GameConstants.GAME_WIDTH / 2, GameConstants_1.GameConstants.GAME_HEIGHT / 2, "bg");
        background.anchor.set(.5);
        var title = this.add.image(GameConstants_1.GameConstants.GAME_WIDTH / 2, 150, "texture_atlas_1", "logo");
        title.scale.y = GameVars_1.GameVars.scaleY;
        title.anchor.set(.5, 0);
        this.clicked = false;
        // BUTTONS
        var playButton = this.add.button(GameConstants_1.GameConstants.GAME_WIDTH / 2, 500, "texture_atlas_1", this.onClickPlay, this);
        playButton.setFrames("btn_play", "btn_play", "btn_play");
        playButton.anchor.set(.5);
        playButton.scale.y = GameVars_1.GameVars.scaleY;
        playButton.input.pixelPerfectOver = true;
        playButton.forceOut = true;
        this.soundButton = this.add.button(GameConstants_1.GameConstants.GAME_WIDTH - 10, 10, "texture_atlas_1", this.onClickSound, this);
        if (GameVars_1.GameVars.sound) {
            this.soundButton.setFrames("btn_sound_on", "btn_sound_on", "btn_sound_on");
        }
        else {
            this.soundButton.setFrames("btn_sound_off", "btn_sound_off", "btn_sound_off");
        }
        this.soundButton.anchor.set(1, 0);
        this.soundButton.scale.y = GameVars_1.GameVars.scaleY;
        this.soundButton.input.pixelPerfectOver = true;
        this.soundButton.forceOut = true;
        var tutorialButton = this.add.button(GameConstants_1.GameConstants.GAME_WIDTH / 2 - 180, GameConstants_1.GameConstants.GAME_HEIGHT - 60, "texture_atlas_1", this.onClickHow, this);
        tutorialButton.setFrames("btn_splash", "btn_splash", "btn_splash");
        tutorialButton.anchor.set(.5);
        tutorialButton.scale.y = GameVars_1.GameVars.scaleY;
        tutorialButton.forceOut = true;
        var tutorialText = this.add.text(GameConstants_1.GameConstants.GAME_WIDTH / 2 - 180, GameConstants_1.GameConstants.GAME_HEIGHT - 60, "HOW TO PLAY", { font: "30px Futura", fill: "#ffffff" });
        tutorialText.setShadow(3, 3, "rgba(0,0,0,0.5)", 3);
        tutorialText.anchor.set(.5);
        tutorialText.scale.y = GameVars_1.GameVars.scaleY;
        var scoringButton = this.add.button(GameConstants_1.GameConstants.GAME_WIDTH / 2 + 180, GameConstants_1.GameConstants.GAME_HEIGHT - 60, "texture_atlas_1", this.onClickScoring, this);
        scoringButton.setFrames("btn_splash", "btn_splash", "btn_splash");
        scoringButton.anchor.set(.5);
        scoringButton.scale.y = GameVars_1.GameVars.scaleY;
        scoringButton.forceOut = true;
        var scoringText = this.add.text(GameConstants_1.GameConstants.GAME_WIDTH / 2 + 180, GameConstants_1.GameConstants.GAME_HEIGHT - 60, "SCORE SYSTEM", { font: "30px Futura", fill: "#ffffff" });
        scoringText.setShadow(3, 3, "rgba(0,0,0,0.5)", 3);
        scoringText.anchor.set(.5);
        scoringText.scale.y = GameVars_1.GameVars.scaleY;
        this.scoreLayer = new ScoreLayer_1.ScoreLayer(this.game);
        this.scoreLayer.visible = false;
        this.add.existing(this.scoreLayer);
    };
    SplashState.prototype.shutdown = function () {
        SplashState.currentInstance = null;
        _super.prototype.shutdown.call(this);
    };
    SplashState.prototype.onBackButtonPressed = function () {
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
    };
    SplashState.prototype.onClickSound = function () {
        if (GameVars_1.GameVars.sound) {
            GameVars_1.GameVars.sound = false;
            this.soundButton.setFrames("btn_sound_off", "btn_sound_off", "btn_sound_off");
        }
        else {
            GameVars_1.GameVars.sound = true;
            this.soundButton.setFrames("btn_sound_on", "btn_sound_on", "btn_sound_on");
        }
        if (!GameVars_1.GameVars.sound) {
            AudioManager_1.AudioManager.getInstance().isSoundMuted = true;
            AudioManager_1.AudioManager.getInstance().mute();
        }
        else {
            AudioManager_1.AudioManager.getInstance().isSoundMuted = false;
            AudioManager_1.AudioManager.getInstance().unmute();
        }
        oMetaManager.localSetItem(GameConstants_1.GameConstants.AUDIO_STATE_KEY, JSON.stringify(GameVars_1.GameVars.sound));
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
    };
    SplashState.prototype.onClickPlay = function () {
        if (this.clicked) {
            return;
        }
        this.clicked = true;
        SplashState.currentInstance.game.state.start("BoardState", true, false);
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
    };
    SplashState.prototype.onClickHow = function () {
        this.tutorialLayer = new TutorialLayer_1.TutorialLayer(this.game);
        this.add.existing(this.tutorialLayer);
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
    };
    SplashState.prototype.onClickScoring = function () {
        this.scoreLayer.visible = true;
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
    };
    SplashState.currentInstance = null;
    return SplashState;
}(Phaser.State));
exports.SplashState = SplashState;
